import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";
import logo from "../images/Apex-png.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">

        {/* BRAND */}
        <div className="footer-col footer-brand">
          <div className="footer-brand-row">
            <img
              src={logo}
              alt="Apex Trade Connect Logo"
              className="footer-logo"
            />

            <div className="footer-brand-text">
              <h3>Apex Trade Connect FZ-LLC</h3>

              <p className="footer-desc">
                Apex Trade Connect is a general trading company specializing in
                quality industrial products and reliable supply solutions.
              </p>

              <p className="footer-location">
                <i className="fa fa-map-marker"></i>
                Ras Al Khaimah, United Arab Emirates
              </p>
            </div>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h4>Contact</h4>
          <p>
            <i className="fa fa-phone"></i>
            +971 58 573 5792
          </p>
          <p>
            <i className="fa fa-envelope"></i>
            info@apextrade.ae
          </p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Apex Trade Connect FZ-LLC. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
